// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const RemoveLiquidity = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M14.625 10.688c0-5.063-5.625-9-5.625-9s-5.625 3.937-5.625 9a5.625 5.625 0 0 0 11.25 0Z"
    />
    <path stroke="currentColor" strokeLinejoin="round" d="M6.188 9.985h5.625" />
  </svg>
);
const ForwardRef = forwardRef(RemoveLiquidity);
export default ForwardRef;
